<template>
    <div class="password-step">
      <b-container>
        <b-row align-h="center">
          <b-col>
            <div class="align-self-center text-center">
              <b-img
                  class="logo"
                  :src="logo.path"
                  alt="Main Logo"
              />
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col></b-col>
          <b-col cols="8">
            <div class="align-self-center text-center">
              <h5>Welcome Back!</h5>
              <p class="text-subheading">Enter your Sellers Shield password and we'll send you right along!</p>
            </div>
          </b-col>
          <b-col></b-col>
        </b-row>
        <b-form
            @submit.prevent="$emit('submit')"
        >
          <b-row>
            <b-col></b-col>
            <b-col cols="8">
              <div class="align-self-center text-center">
              <b-form-group>
                <label for="password">Password</label>
                <b-input-group>
                  <b-form-input
                      :disabled="loading"
                      :value="value.password"
                      @input="onPasswordChange"
                      required
                      type="password"
                      :class="{'is-invalid': errors.length > 0}"

                  />
                </b-input-group>
                <template v-if="errors.length">
                  <b-form-invalid-feedback
                      :key="errIndex"
                      class="d-block"
                      v-for="(error, errIndex) in errors"
                  >
                    <i class="fal fa-exclamation-circle"/>
                    {{ error }}
                  </b-form-invalid-feedback>
                </template>
              </b-form-group>
              </div>
            </b-col>
            <b-col></b-col>
          </b-row>

          <b-row>
            <b-col></b-col>
            <b-col cols="8" class="align-self-center text-center">
              <b-form-group>
                <div class="align-self-center text-center">

                <b-btn
                    :disabled="loading"
                    pill
                    size="lg"
                    type="button"
                    class="white-button"
                    @click="goBack"
                >
                  Back
                </b-btn>

                <b-btn
                    :disabled="loading"
                    pill
                    size="lg"
                    type="submit"
                    class="gold-button"
                >
                  Submit
                </b-btn>
                <b-btn
                    :disabled="loading"
                    block
                    size="lg"
                    variant="link"
                    @click="goToForgot"
                >
                  Forgot Password
                </b-btn>
                </div>
              </b-form-group>

            </b-col>
            <b-col></b-col>
          </b-row>

        </b-form>
      </b-container>


    </div>
</template>

<script>
import "./PasswordStep.scss";
import {pageRedirect} from "@helpers/router-helper";

export default {
    name: 'PasswordStep',
    props: {
        value: {
            type: Object,
            required: true,
            default: () => {
            }
        },
        errors: {
            type: Array,
            required: false,
            default: () => ([])
        },
        loading: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    data: () => ({
      logo: {
        path: require('@assets/images/ss-wordmark-black.png'),
      },
    }),
    methods: {
        onInput(value) {
            this.$emit('input', this.value);
        },
        onPasswordChange(value) {
            this.value.password = value;
            this.onInput(value);
        },
        async goToForgot() {
            await pageRedirect(window.env.APP_URL, '/forgot-password');
        },
        goBack() {
          this.$emit('welcome');
        }
    }

}
</script>
